<script setup>
const props = defineProps({
  userData: {
    type: Object,
    required: true,
  },
})
</script>

<template>
  <q-card
    flat
    bordered
  >
    <q-card-section>
      <div class="text-h6">
        {{ $t('user.data') }}
      </div>

      <div class="column q-gutter-y-sm">
        <div>
          <div class="text-caption text-grey-8">
            {{ $t('auth.username') }}
          </div>
          <div class="text-body1">
            {{ props.userData.username || '-' }}
          </div>
        </div>

        <div>
          <div class="text-caption text-grey-8">
            {{ $t('auth.email') }}
          </div>
          <div class="text-body1">
            {{ props.userData.email || '-' }}
          </div>
        </div>

        <div>
          <div class="text-caption text-grey-8">
            {{ $t('auth.phoneNumber') }}
          </div>
          <div class="text-body1">
            {{ props.userData.phone_number || '-' }}
          </div>
        </div>

        <div>
          <div class="text-caption text-grey-8">
            {{ $t('auth.fullName') }}
          </div>
          <div class="text-body1">
            {{ props.userData.first_name }} {{ props.userData.last_name }}
          </div>
        </div>
      </div>
    </q-card-section>
  </q-card>
</template>
